import type { AnchorHTMLAttributes, ReactNode } from "react";

export const renderPlainLink = (attrs: AnchorHTMLAttributes<HTMLAnchorElement> & { children?: ReactNode }) => {
  return <a {...attrs}>{attrs.children}</a>;
};
